import classNames from "classnames";
import { FC, PropsWithChildren } from "react";
import styles from "./FormFieldsContainer.module.css";

type FormFieldsContainerProps = PropsWithChildren<{
  className?: string;
}>;

const FormFieldsContainer: FC<FormFieldsContainerProps> = ({ children, className }: FormFieldsContainerProps) => {
  return (
    <div className={classNames(styles.container, className)}>
      <div className={styles["form-fields"]}>{children}</div>
    </div>
  );
};

export default FormFieldsContainer;
